import React from "react";
import {Row, Col, Tabs, Select, Radio, Button} from "antd";
import "./TransferDetailsPanel.scss";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import {formatMoney, formatExchangeRate, getCountryCodeForCurrency} from "utils/utils";
import {displayNumberWithComma} from "../../utils/utils";
import FieldValueSignUpVerticalCell from "../general/FieldValueSingUpVerticalCell";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import config from "../../config";
import {displayError} from "../../common/notifications";
import CurrencySelector from "../CurrencySelector";
import ReactCountryFlag from "react-country-flag";

const { TabPane } = Tabs;

class TransferDetailsPanel extends React.Component {

  state={
    activeTabFee: this.props.transfer ? this.props.transfer.activeTabFee || 'local' : 'local',
    swiftOur:this.props.transferRoute ?this.props.transferRoute.swiftOur : null,
    swiftBen:this.props.transferRoute ?this.props.transferRoute.swiftBen : null,
    swiftSha:this.props.transferRoute ?this.props.transferRoute.swiftSha : null,
    dbsChargeBearer: this.props.transfer ? this.props.transfer.dbsChargeBearer || 'SHAR' : 'SHAR',
    showSwift:false,
    showFee:null
  }

  componentDidMount() {
      this.initData();
  }

  initData = () =>{
    let dbsChargeBearer = this.state.dbsChargeBearer;
    let activeTabFee = this.state.activeTabFee;
    // let showSwift = this.state.showSwift;

    let swiftSha = this.props.transferRoute.swiftSha;
    let swiftBen = this.props.transferRoute.swiftBen;
    let swiftOur = this.props.transferRoute.swiftOur;

    let feeArr = [];
    feeArr.push({type:"SHAR",fee:swiftSha});
    feeArr.push({type:"CRED",fee:swiftBen});
    feeArr.push({type:"DEBT",fee:swiftOur});

    let fee=this.props.fee;
    if(!this.props.transferRoute.allowPayoutLocal && this.props.transferRoute.allowSwiftFee) {

      feeArr = feeArr.filter(item => item.fee && item.fee!=0).sort((a,b) => a.fee-b.fee);

      if(swiftSha && swiftSha!=0) {
        fee = swiftSha;
      }else if(swiftBen && swiftBen!= 0){
        fee = swiftBen;
      }else if(swiftOur && swiftOur!= 0){
        fee = swiftOur;
      }
    }
    let minFee = fee;

    if(swiftSha != null || swiftBen!=null && swiftOur!=null) {
      // showSwift=true;
    }else {
      activeTabFee = 'local';
      // showSwift=false;
    }
    if (swiftSha != null && swiftSha < minFee) {
      minFee = swiftSha;
      activeTabFee = 'swift';
      dbsChargeBearer = 'SHAR';
    }

    if (swiftBen != null && swiftBen < minFee) {
      minFee = swiftBen;
      dbsChargeBearer = 'CRED';
      activeTabFee = 'swift';
    }

    if (swiftOur != null && swiftOur < minFee) {
      minFee = swiftOur
      dbsChargeBearer = 'DEBT';
      activeTabFee = 'swift';
    }

    if(activeTabFee == 'swift') {
      if (dbsChargeBearer === 'SHAR' && (!swiftSha || swiftSha == 0)) {
        if (feeArr.length>0) {
          dbsChargeBearer = feeArr[0].type;
          minFee = feeArr[0].fee;
        }
      } else if (dbsChargeBearer === 'CRED' && (!swiftBen || swiftBen == 0)) {
        if (feeArr.length>0) {
          dbsChargeBearer = feeArr[0].type;
          minFee = feeArr[0].fee;
        }
      } else if (dbsChargeBearer === 'DEBT' && (!swiftOur || swiftOur == 0)) {
        if (feeArr.length>0) {
          dbsChargeBearer = feeArr[0].type;
          minFee = feeArr[0].fee;
        }
      }
    }

    this.setState({
      swiftOur:swiftOur,
      swiftBen:swiftBen,
      swiftSha:swiftSha,
      dbsChargeBearer:dbsChargeBearer,
      activeTabFee:activeTabFee,
      minFee:minFee,
      swiftFee:minFee,
      // showSwift:showSwift
    },()=>{
      let swiftFee = this.state.swiftFee;
      this.props.updateSwiftFee(swiftFee,this.state.activeTabFee,this.state.dbsChargeBearer)
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.transferRoute.swiftSha != this.state.swiftSha
        || prevProps.transferRoute.swiftBen != this.state.swiftBen
        || prevProps.transferRoute.swiftOur != this.state.swiftOur
    ) {
      this.initData();
    }
    if (this.props.fee != prevProps.fee) {
      if (this.props.transferRoute.swiftBen || this.props.transferRoute.swiftSha
          || this.props.transferRoute.swiftOur) {
        this.props.updateSourceTargetAfterChangeFee();
      }
    }
    if((this.state.activeTabFee==='swift' || this.state.activeTabFee===undefined) && !prevProps.transferRoute.allowSwiftFee && prevProps.transferRoute.allowLocalPayout) {
        this.setState({
          activeTabFee:'local'
        },()=>{
          this.props.updatePaymentActiveTabFee(this.state.activeTabFee);
        })
    }else if ((this.state.activeTabFee==='local' || this.state.activeTabFee===undefined) && prevProps.transferRoute.allowSwiftFee && !prevProps.transferRoute.allowLocalPayout){
      this.setState({
        activeTabFee:'swift'
      },()=> {
        this.props.updatePaymentActiveTabFee(this.state.activeTabFee)
      })
    }else if(this.state.activeTabFee != undefined && !prevProps.transferRoute.allowSwiftFee && !prevProps.transferRoute.allowLocalPayout) {
      this.setState({
        activeTabFee:undefined
      },()=> {
        this.props.updatePaymentActiveTabFee(this.state.activeTabFee)
      })
    }else if(this.props.transferRoute.allowSwiftFee && this.props.transferRoute.allowLocalPayout) {
      let sourceValue = this.props.sourceValue;
      let targetValue = this.props.targetValue;
      if ((sourceValue && sourceValue.currency != prevProps.sourceValue.currency)
          || (targetValue && targetValue.currency != prevProps.targetValue.currency)
      ) {
        this.initData();
      }
    }
  }

  formatFee = fee => {
    return formatMoney(fee) + " " +  (this.props.transferRoute ? this.props.transferRoute.feeCurrency  : this.props.sourceValue.currency);
    // return formatMoney(fee) + " " +  this.props.sourceValue.currency;
  };

  formatArrivalEstimation = estimation => {
    return "in " + estimation + " day";
  };

  generateExchangeRate = () => {
    const { sourceValue, targetValue } = this.props;
    let exchangeRate = this.props.exchangeRate;
    let indicativeOrder = this.props.transfer &&  this.props.transfer.indicativeOrder;
    if(exchangeRate) {
    if(targetValue.currency === 'VND'
        || targetValue.currency === 'IDR'){
      if(indicativeOrder){
        return (
            <span>
          1 {sourceValue.currency} = {displayNumberWithComma(exchangeRate.toFixed(0))} {targetValue.currency} <span style={{color:'red', fontSize:'13px'}}>(Indicative)</span>
        </span>
        )
      }else{
        return (
            <span>
          1 {sourceValue.currency} = {displayNumberWithComma(exchangeRate.toFixed(0))} {targetValue.currency}
        </span>
        )
      }

    }else{
      if(indicativeOrder){
        return (
            <span>
          1 {sourceValue.currency} = {formatExchangeRate(exchangeRate)} {targetValue.currency} <span style={{color:'red', fontSize:'13px'}}>(Indicative)</span>
        </span>
        )
      }else{
        return (
            <span>
          1 {sourceValue.currency} = {formatExchangeRate(exchangeRate)} {targetValue.currency} 
        </span>
        )
      }
      
    }
    }
  };

  generateInverseRate = () => {
    const { sourceValue, targetValue, factors } = this.props;
    if (Object.keys(factors).length !== 0) {
      if (factors[sourceValue.currency][targetValue.currency] === 1) {
        return (
            <span>
        1 {targetValue.currency} = {formatExchangeRate(1 / this.props.exchangeRate)} {sourceValue.currency}
      </span>
        )
      } else {
        let factor = factors[sourceValue.currency][targetValue.currency];
        return (
            <span>
        {factor} {targetValue.currency} = {formatExchangeRate((1 / this.props.exchangeRate) * factor)} {sourceValue.currency}
      </span>
        )
      }
    }

  };

  changeChargeOps = (e) =>{
    let chargOption = e.target.value;
    let swiftSha = this.props.transferRoute.swiftSha;
    let swiftBen = this.props.transferRoute.swiftBen;
    let swiftOur = this.props.transferRoute.swiftOur;

    let swiftFeeTmp = swiftSha;
    if(chargOption === 'SHAR') {
      swiftFeeTmp = swiftSha;
    }else if(chargOption === 'DEBT'){
      swiftFeeTmp = swiftOur;
    }else if(chargOption === 'CRED'){
      swiftFeeTmp = swiftBen;
    }

    this.setState({
      dbsChargeBearer: chargOption,
      swiftFee: swiftFeeTmp
    },()=>{
      let swiftFee = this.state.swiftFee;
      // if(this.state.dbsChargeBearer === 'SHAR') {
      //   swiftFee=swiftFee/2;
      // }
      this.props.updateSwiftFee(swiftFee,this.state.activeTabFee,this.state.dbsChargeBearer);
    })
  }

  enableBtn = {
    color:'#1890ff',
    fontWeight:'bold'
  }

  render() {
    const intl = this.props.useIntl;
    let localActive = this.state.activeTabFee==='local';
    let swiftActive = this.state.activeTabFee==='swift';

    let colFee = {
      border:'1px solid #dddddd',
      textAlign:'left',
      padding:'10px 5px'
    }

    let colFeeCenter = {
      border:'1px solid #dddddd',
      textAlign:'center',
      padding:'10px 5px'
    }

    let styleSwiftActive = swiftActive ? this.enableBtn : null;
    let styleLocalActive = localActive ? this.enableBtn : null;
    // let convertedAmount = this.props.convertedAmount;
    let propsFree = this.props.fee || 0;
    let convertedAmount = this.props.sourceValue.amount - propsFree;
    let swiftCurrency = (this.props.transferRoute && this.props.transferRoute.feeCurrency )? this.props.transferRoute.feeCurrency : this.props.sourceValue.currency;
    let activeSwiftSHA = this.state.activeTabFee==='swift' && this.state.dbsChargeBearer === 'SHAR';

    let shaDisabled = !this.state.swiftSha || this.state.swiftSha ==0;
    let ourDisabled = !this.state.swiftOur || this.state.swiftOur ==0;
    let benDisabled = !this.state.swiftBen || this.state.swiftBen ==0;
    return (
      <div className="transfer-details-panel-no-pad-hoz">
        <Row className={'row-active-fee'}>
          <Col md={8} sm={12}>
            <Row>
              <Col sm={12} span={12} className={'gutter-row'}>
              <Button
                  disabled={!this.props.transferRoute.allowLocalPayout}
                  onClick={()=>{
                if(swiftActive) {
                  this.setState({
                    activeTabFee:'local'
                  },()=>{
                    this.props.updateSwiftFee(this.state.swiftFee,this.state.activeTabFee,this.state.dbsChargeBearer);
                  })
                }
              }}
                      icon={localActive ? 'check' : ''}
              style={{...styleLocalActive,width:'100%'}}
              >
                {intl.formatMessage({id:"app.panel.transferdetailspanel.local.fee"})}
              </Button>
              </Col><Col sm={12} span={12}>
              <Button
                  disabled={!this.props.transferRoute.allowSwiftFee}
                  onClick={()=>{
                if(localActive) {
                  this.setState({
                    activeTabFee:'swift',
                  },()=>{
                    let fee = propsFree;
                    if (this.state.dbsChargeBearer ){
                      if(this.state.swiftFee !=null ) {
                        fee = this.state.swiftFee;
                      }
                      // if(this.state.dbsChargeBearer === 'SHAR') {
                      //   if(this.state.swiftSha!=null)
                      //   fee = this.state.swiftSha/2;
                      // }
                    }
                    this.props.updateSwiftFee(fee,this.state.activeTabFee,this.state.dbsChargeBearer);
                  })
                }
              }}
                      icon={this.state.activeTabFee==='swift' ? 'check' : ''}
                      style={{...styleSwiftActive,width:'100%'}}
              >
                {intl.formatMessage({id:"app.panel.transferdetailspanel.swift.fee"})}
              </Button>
            </Col>
            </Row>
            {/*{this.buildFeeArea()}*/}
          </Col>
          <Col md={4} sm={12} ></Col>
          <Col md={9} sm={12} style={{textAlign: "center"}}>
            <FieldValueSignUpVerticalCell
              value={this.generateExchangeRate()}
              fieldclass="field-value-cell-sendmoney-value"
            />
            <FieldValueSignUpVerticalCell
                value={this.generateInverseRate()}
                fieldclass="field-value-cell-sendmoney-value-sm"
            />
          </Col>
        </Row>
        <Row style={{marginTop: "14px"}}>
          <Col md={7} sm={12}>
            {
              this.state.activeTabFee === 'local' &&
                <div style={{marginLeft:10}}>
                  <div style={{marginBottom:5}}><b>{intl.formatMessage({id: "app.panel.transferdetailspanel.fee.currency"})}</b></div>
                  <span className="currency-selector-container">
          <Select
              showSearch={window.innerWidth <= 600 ? false : true}
              {...this.props}
              style={{width: "100", fontSize: 16, border: "none"}}
              defaultValue={this.props.sourceValue.currency}
              optionFilterProp="children"
              mode={"default"}
              filterOption={(input, option) => option.props.children[1].props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

              }
          >
            {(swiftCurrency ? [swiftCurrency] : [this.props.sourceValue.currency]).map((currency, idx) => {
              return (<Select.Option key={currency} currency={currency}>
                <ReactCountryFlag code={getCountryCodeForCurrency(currency)}/>
                <span style={{marginLeft: "5px"}}>{currency}</span>
              </Select.Option>);
            })}
          </Select>
        </span>

                </div>
            }
            {this.state.activeTabFee === 'swift' &&
                <div style={{marginLeft: 10}}>
                  <div style={{marginBottom:5}}><b>{intl.formatMessage({id:"app.panel.transferdetailspanel.charge.option"})}</b></div>
                  <Radio.Group style={{width:'100%'}} value={this.state.dbsChargeBearer} onChange={this.changeChargeOps}>
                    <Row align={'middle'}
                    >
                      <Col span={10} style={colFee}>
                        <Radio style={{paddingLeft:5}} value="SHAR" disabled={shaDisabled} > <b>SHA</b></Radio>
                      </Col>
                      <Col span={14} style={colFeeCenter}>
                        <b>
                          {shaDisabled ? <span>&nbsp;</span> :
                              `${swiftCurrency}  ${formatMoney(this.state.swiftSha)}`
                          }</b>
                      </Col>

                    </Row>
                    <Row
                    >
                      <Col span={10} style={colFee} className="gutter-row">
                        <Radio style={{paddingLeft:5}} value="DEBT" disabled={ourDisabled} > <b>OUR</b> </Radio>
                      </Col>
                      <Col span={14} style={colFeeCenter} className="gutter-row">
                        <b>{ourDisabled ? <span>&nbsp;</span> :
                            `${swiftCurrency}  ${formatMoney(this.state.swiftOur)}`
                        }</b>
                      </Col>

                    </Row>
                    <Row>
                      <Col span={10} style={colFee} className="gutter-row">
                        <Radio style={{paddingLeft:5}} value="CRED" disabled={benDisabled}> <b>BEN</b> </Radio>
                      </Col >
                      <Col span={14} style={colFeeCenter} className="gutter-row">
                        <b>{benDisabled ? <span>&nbsp;</span> :
                            `${swiftCurrency}  ${formatMoney(this.state.swiftBen)}`
                        }</b>
                      </Col>
                    </Row>
                  </Radio.Group>
                </div>
            }


          </Col>
          <Col md={6} sm={12} style={{textAlign: 'center'}}>
            <FieldValueVerticalCell
              title={intl.formatMessage({id: "app.panel.transferdetailspanel.remittancefees"})}
              value={this.formatFee(propsFree)}
            />
          </Col>
          {activeSwiftSHA ? <Col md={6} sm={9} style={{textAlign: 'center'}}>
              <FieldValueVerticalCell
                  title={intl.formatMessage({id: "app.panel.transferdetailspanel.recipient.charge"})}
                  value={this.formatFee(propsFree)}
              />
          </Col> : <Col md={6} sm={9} style={{textAlign: 'center'}}> </Col>}
          <Col md={5} sm={12} style={{textAlign: 'center'}}>
            <FieldValueVerticalCell
                title={intl.formatMessage({id: "app.panel.transferdetailspanel.amountconverted"})}
                value={convertedAmount == 0 ? "0.00" : displayNumberWithComma(convertedAmount)}
                currency={this.props.sourceValue.currency}
            />
          </Col>
        </Row>
        {/*<Row style={{textAlign: "center", marginTop: "8px"}}>
          <Col md={4} sm={12}>
            &nbsp;
          </Col>
          <Col md={17} sm={12} style={{fontSize: "94%"}}>
            {config.swiftTargetCcyBankCharges.includes(this.props.targetValue.currency) && (
            <FormattedMessage id="app.panel.transferdetailspanel.swiftbankchargesmayapply"/>
            )}
          </Col>
        </Row>*/}
        
      </div>
    );
  }
}

export default withUseIntl(TransferDetailsPanel);